module.exports = __webpack_public_path__ + "static/media/27OCHA1.2bcb29c7.jpg";